module.exports = __webpack_public_path__ + "img/device_1014_1.f1a63286.svg";